import { defineComponent, reactive, toRefs, computed } from "vue";
import { useRouter } from "vue-router";
import { store } from "./store/PasswordReissueStore";
import { MsgBox } from "~/components/MsgBox";
import { Log, Validator, presence, maxLength } from "~/extensions/utils";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { commonStore } from "~/store/CommonStore";
import { AuthorizationCode } from "~/api/data/AuthorizationCode";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
const log = Log.create("PasswordReissueCheckPage");
const constraints = computed(() => ({
    authCode: {
        presence: presence(false, commonStore.messages.PV0001),
        length: maxLength(16)
    }
}));
export default defineComponent({
    name: "PasswordReissueCheckPage",
    beforeRouteEnter(to, from, next) {
        if (from.name !== "password-reissue-entry") {
            next({ name: "password-reissue-entry" });
            return;
        }
        if (isNullOrUndefined(store.mailAddress) || store.mailAddress === "") {
            next({ name: "password-reissue-entry" });
            return;
        }
        next();
    },
    setup() {
        const data = reactive(new AuthorizationCode());
        const valid = reactive(new Validator(data, constraints.value));
        const router = useRouter();
        const submit = async () => {
            valid.reset();
            if (valid.error || !data.authCode) {
                MsgBox.error(commonStore.messages.PV0017);
                return;
            }
            try {
                Loading.show();
                await store.validateCodePasswordReissue(data);
                router.push({ name: "password-reissue-complete" });
            }
            catch (ex) {
                if (!valid.handle(ex)) {
                    log.error("PasswordReissueCheckPage", ex);
                    MsgBox.error(ex.message);
                }
            }
            finally {
                Loading.hide();
            }
        };
        return {
            ...toRefs(store),
            data,
            valid,
            submit
        };
    }
});
